import React from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import Button from './Button';

/**
 * Generic confirmation dialog, on the same Headless UI Dialog pattern as
 * ImportCollectionModal. (ModalContent.js, the old react-modal wrapper, is
 * unused and renders invisible.)
 */
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  confirmIconClass,
  onConfirm,
  onClose,
}) => (
  <Dialog open={open} onClose={onClose} className="relative z-50">
    <div className="fixed inset-0 bg-black/60" aria-hidden="true" />
    <div className="fixed inset-0 flex items-start justify-center p-4 overflow-y-auto">
      <DialogPanel className="w-full max-w-md bg-darkColor text-white rounded-md p-6 flex flex-col gap-y-4 mt-24">
        <DialogTitle className="text-xl">
          <i className="fas fa-exclamation-triangle mr-2"></i>
          {title}
        </DialogTitle>

        {message && <p className="text-sm text-gray-300">{message}</p>}

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            className="w-full sm:w-1/2"
            iconClass={confirmIconClass || 'fas fa-check'}
            onClick={onConfirm}>
            {confirmLabel || 'Confirmar'}
          </Button>
          <Button
            className="w-full sm:w-1/2"
            iconClass="fas fa-times"
            onClick={onClose}>
            Cancelar
          </Button>
        </div>
      </DialogPanel>
    </div>
  </Dialog>
);

export default ConfirmDialog;
